import React from 'react';
import { SpaceLabel } from '../../types/TaskLabel';
import CustomTooltip from './Tooltip/CustomTooltip';

interface LabelOverflowPillProps {
  hiddenLabels: SpaceLabel[];
}

// Fixed h-5 (20px) matches LabelChip's intrinsic text-sm line-height so the
// trigger row in label dropdowns does not grow when the overflow pill appears.
const LabelOverflowPill: React.FC<LabelOverflowPillProps> = ({ hiddenLabels }) => {
  if (hiddenLabels.length === 0) return null;

  return (
    <CustomTooltip
      title={
        <div>
          {hiddenLabels.map((label, index) => (
            <div key={index}>{label?.title}</div>
          ))}
        </div>
      }
    >
      <div className="inline-flex items-center justify-center px-2 h-5 bg-neutral-200 rounded text-neutral-900 text-sm font-normal">
        +{hiddenLabels.length}
      </div>
    </CustomTooltip>
  );
};

export default LabelOverflowPill;
